/** Minimum length after trim (covers short national codes). */
export const POSTAL_CODE_MIN_LENGTH = 2;

/** Maximum length after trim (US ZIP+4, UK, Canada, Brazil CEP, etc.). */
export const POSTAL_CODE_MAX_LENGTH = 12;

/**
 * Permissive pattern for international postal codes passed to Stripe `address_zip`.
 * Allows letters, digits, spaces, and hyphens; must start and end with a letter or digit.
 *
 * Examples: 60601, 12345-6789, SW1A 1AA, K1A 0B1, 1234 AB
 */
export const POSTAL_CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 -]{0,10}[A-Za-z0-9]$/;

export const POSTAL_CODE_FORMAT_MESSAGE =
  'Enter a valid postal code (letters, numbers, spaces, and hyphens only)';

export function isValidPostalCode(value: string | undefined | null): boolean {
  const trimmed = value?.trim() ?? '';
  if (
    trimmed.length < POSTAL_CODE_MIN_LENGTH ||
    trimmed.length > POSTAL_CODE_MAX_LENGTH
  ) {
    return false;
  }
  return POSTAL_CODE_PATTERN.test(trimmed);
}
